export default {
  notAccomplishNum: 0,
  secretaryName: "",
  secretaryPhone: "",
};
